import { render, staticRenderFns } from "./Servicio.vue?vue&type=template&id=3ec9bfc8&scoped=true"
import script from "./Servicio.vue?vue&type=script&lang=js"
export * from "./Servicio.vue?vue&type=script&lang=js"
import style0 from "./Servicio.vue?vue&type=style&index=0&id=3ec9bfc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec9bfc8",
  null
  
)

export default component.exports